export const ASSIGN_ROOM_REQUEST = 'ASSIGN_ROOM_REQUEST'
export const ASSIGN_ROOM_SUCCESS = 'ASSIGN_ROOM_SUCCESS'
export const ASSIGN_ROOM_FALIURE = 'ASSIGN_ROOM_FALIURE'
